import React, {useEffect, useState, useRef, useLayoutEffect} from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import windowOffsetTopState from "../../state/ui/windowOffsetTopState";
import PlyrPlayer from "./PlyrPlayer";
import VimeoPlayer from "./VimeoPlayer";
import spaceState from "../../state/spaceState";
import useFetchPlayerData from "../../hooks/useFetchPlayerData";
import keyboardState from "../../state/ui/keyboardState";
import windowDimensionState from "../../state/ui/windowDimensionState";
import largeVideoState from "../../state/ui/largeVideoState";
import MuxPlayer from "./MuxPlayer";

export default function Video() {
  const offsetTop = useRecoilValue(windowOffsetTopState);
  const keyboard = useRecoilValue(keyboardState);
  const windowDimensions = useRecoilValue(windowDimensionState);

  // if window height - video height > 400, show large video size (60% -> 70%)
  const [largeVideo, setLargeVideo] = useRecoilState(largeVideoState);
  const videoRef = useRef(null)

  useLayoutEffect(() => {
    if(videoRef.current){
      setLargeVideo(windowDimensions.height-videoRef.current.clientHeight > 400 ? true : false)
    }
  }, [videoRef.current])

  const {isStarted, isEnded} = useRecoilValue(spaceState);
  const { data, isLoading, isError } = useFetchPlayerData();
  const [player, setPlayer] = useState({
    src: null,
    provider: null,
    loop: false,
    sync: false,
  });

  useEffect(() => {
    if(!data?.hash) {
      return;
    }

    if (isEnded) {
      setPlayer({
        src: data?.post?.src || data.src,
        provider: data?.post?.provider || data.provider,
        loop: true,
        sync: false,
        token: data?.post?.token
      });
    }
    else if (!isEnded && !isStarted && data?.pre) {
      setPlayer({
        src: data?.pre?.src,
        provider: data?.pre?.provider,
        loop: true,
        sync: false,
        token: data?.pre?.token
      });
    }
    else {
      setPlayer({
        src: data?.src,
        provider: data?.provider,
        loop: false,
        sync: data?.sync,
        token: data?.token
      });
    }
  }, [data?.hash, isEnded, isStarted]);

  // useEffect(() => {
  //   console.log(player);
  // }, [player]);

  if(!player.src || !player.provider) {
    return null;
  }
  
  return (
    <div
      ref={videoRef}
      className={`video ${largeVideo ? 'video-large':''}`}
      style= {{
        // "--video-offset": offsetTop
        top: keyboard && windowDimensions.width < 768 ? offsetTop + 16 : 0
      }}
    >
      {/* <p className="absolute top-0 right-0 bottom left-0 text-white z-50">{windowDimensions.height-videoHeight}</p> */}
        {player.provider === 'vimeo-native' ? (
          <VimeoPlayer className="video-container bg-black" {...player} />
        ) : player.provider === 'mux' ? (
          <MuxPlayer className="video-container bg-black" {...player} />
        ) : (
          <PlyrPlayer className="video-container-plyr bg-black" {...player} />
        )}
        
    </div>
  )
}
